import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
// Placeholder images - replace with actual yacht category images
import MotorYachtImg from "../../assets/images/seascape-experiences-mykonos-greece-cyclades-fleet-rental-charter-falcon-motor-yacht-boat-0353_0.webp";
import SailingYachtImg from "../../assets/images/seascape-experiences-mykonos-greece-cyclades-fleet-rental-charter-beneteau-sailing-yacht-boat-0865.webp"; 
import CatamaranImg from "../../assets/images/seascape-experiences-mykonos-sunset-charter-yacht-daily-cruise-yacht-rental01_0.webp";
import CruisersImg from "../../assets/images/seascape-experiences-mykonos-fleet-cruisers-10.webp";
import RibBoatsImg from "../../assets/images/seascape-experiences-mykonos-fleet-ribboats-1021.webp";
import CaiquesImg from "../../assets/images/seascape-experiences-mykonos-fleet-caique-13_1.webp";
import { IoReturnDownForward } from "react-icons/io5";

// Updated data for yacht categories
const yachtCategories = [
  {
    name: "Motor Yachts",
    image: MotorYachtImg,
    value: "Motor Yacht",
    description: "Experience speed and luxury."
  },
  {
    name: "Sailing Yachts",
    image: SailingYachtImg,
    value: "Sailing Yacht",
    description: "Embrace the wind and sea."
  },
  {
    name: "Catamarans",
    image: CatamaranImg,
    value: "Catamaran",
    description: "Spacious and stable cruising."
  },
  {
    name: "Cruisers",
    image: CruisersImg,
    value: "Cruiser",
    description: "Perfect for long journeys."
  },
  {
    name: "Rib Boats",
    image: RibBoatsImg,
    value: "Rib Boat",
    description: "Fast and agile for day trips."
  },
  {
    name: "Caiques",
    image: CaiquesImg,
    value: "Caique",
    description: "Traditional wooden boats."
  }
];

const YachtList = () => { 
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/yachts', { 
      state: {
        selectedCategory: [category.value],
      }
    });
  };

  return (
    <section className="w-full">
      <motion.div
        className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 mt-6 px-4 lg:px-8 max-w-[1440px] mx-auto transition-all"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.5,
          staggerChildren: 0.2
        }}
      >
        {yachtCategories.map((yacht) => ( // Use yachtCategories data
          <motion.div
            key={yacht.name}
            className="w-full cursor-pointer"
            onClick={() => handleCategoryClick(yacht)}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            whileHover={{ y: -10 }}
          >
            <motion.div
              className="relative w-full h-[300px] lg:h-[400px] overflow-hidden flex rounded-lg p-[2px] bg-gradient-to-r from-blue-300 via-blue-500 to-blue-300 shadow-xl bg-gray-200" // Adjusted gradient
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <motion.div
                className="absolute inset-0 bg-black rounded-lg opacity-30 z-10" // Slightly increased opacity
                whileHover={{ opacity: 0.6 }}
                transition={{ duration: 0.3 }}
              />
              <div className="group relative z-10 w-full h-full flex flex-col justify-end p-6">
                {/* Removed IoReturnDownForward and related positioning */}
                <h3
                  className="text-white text-2xl lg:text-3xl tracking-wide JosefinSans font-semibold mb-1 group-hover:translate-x-2 ease-in-out duration-300"
                >
                  {yacht.name}
                </h3>
                <motion.hr
                  className="w-16 border-t-2 border-blue-300 mb-3 group-hover:w-24 ease-in-out duration-300"
                  initial={{ scaleX: 0, originX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                />
                <p className="text-gray-200 font-light text-sm tracking-normal italic select-none z-50 group-hover:translate-x-2 ease-in-out duration-300">
                  {yacht.description} {/* Added description */}
                </p>
              </div>
              <motion.img
                src={yacht.image}
                alt={yacht.name}
                className="absolute inset-0 object-cover h-full w-full rounded-lg z-0" // Positioned image behind text
                initial={{ scale: 1.1 }}
                whileHover={{ scale: 1.15 }}
                transition={{ duration: 0.5 }}
              />
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default YachtList; // Export renamed component
